<template>
    <div>
        {{ resize() }}
    </div>
</template>

<script>
export default {
    name: 'ScreenSize',
    data() {
        return {
            windowWidth: 0,
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.getWindowWidth)
            this.getWindowWidth()
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth)
    },
    methods: {
        getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth
        },
        resize() {
            this.$emit('onChange', this.windowWidth)
        },
    },
}
</script>
